export default __webpack_public_path__ + "static/media/delievers14.d95cc4c4.png";